import { useCallback } from 'react';

import Image from 'next/image';

import Button from 'src/components/buttons/Button';
import { EmptyWishlistBanner as IEmptyWishlistBanner } from 'src/types/commerce';
import { buttonEvent } from 'src/utils/analytics/mixpanel/mixpanelEventsHelper';
import { isServer } from 'src/utils/common';
import { Commerce } from 'src/utils/constants/CommerceConstants';
import { DEVICE_WIDTH_CONSTANTS } from 'src/utils/constants/utilConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import { MIXPANEL_EXPLORE_NOW } from '../../../utils/analytics/mixpanel/mixpanelConstants';
import { BannerWrapper, Text, explore } from './styles';

const EmptyWishlistBanner: React.FC<IEmptyWishlistBanner> = ({
  handleCommerceLayout
}) => {
  const { translations } = useAppStore();
  const {
    plex: {
      ContextualCommerce_Explore = '',
      ContextualCommerce_EmptyCart = ''
    } = {}
  } = translations || {};

  const exploreLooksHandler = useCallback(() => {
    buttonEvent(MIXPANEL_EXPLORE_NOW);
    if (handleCommerceLayout) {
      handleCommerceLayout();
    }
  }, []);

  const getImgWidth = useCallback(() => {
    let width = 170;
    if (!isServer()) {
      const { innerWidth = 0 } = window;
      if (
        innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth600 ||
        innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth1200
      ) {
        width = 187;
      } else if (innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth900) {
        width = 231;
      } else if (innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth1800) {
        width = 229;
      }
    }
    return width;
  }, []);

  const getImgHeight = useCallback(() => {
    let height = 120;
    if (!isServer()) {
      const { innerWidth = 0 } = window;
      if (
        innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth600 ||
        innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth1200
      ) {
        height = 132;
      } else if (innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth900) {
        height = 163;
      } else if (innerWidth >= DEVICE_WIDTH_CONSTANTS.deviceWidth1800) {
        height = 161;
      }
    }
    return height;
  }, []);

  return (
    <BannerWrapper>
      <Image
        src={Commerce.IMG_PATH.replace('<name>', Commerce.EMPTY_WISHLIST)}
        alt="Empty Wishlist Icon"
        width={getImgWidth()}
        height={getImgHeight()}
      />
      <Text>{ContextualCommerce_EmptyCart}</Text>
      <Button
        customStyles={explore}
        title={ContextualCommerce_Explore}
        callback={exploreLooksHandler}>
        {ContextualCommerce_Explore}
      </Button>
    </BannerWrapper>
  );
};

export default EmptyWishlistBanner;
